import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Segment, Divider } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { apiViaje } from "../../../api/viaje";
import { ENTORNO } from "../../../utils/constantes";
import { getrole } from "../../../utils/variablesLocales";
import HomeIcon from "@mui/icons-material/Home";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Alert from "@mui/material/Alert";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";

const apiviaje = new apiViaje();

const ExportarOpa = async () => {
  const respuesta = await apiviaje.obtenerViaje_ParaBancoOpg();

  let Cadena = "";

  for (let i = 0; i < respuesta.length; i++) {
    Cadena = Cadena + respuesta[i].Resultado + "\n";
  }

  const blob = new Blob([Cadena], { type: "text/plain" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.download = "OPG.txt";
  link.href = url;

  link.click();
};

const ExportarRtn = async () => {
  const respuesta = await apiviaje.obtenerViaje_ParaBancoRet();

  let Cadena = "";

  for (let i = 0; i < respuesta.length; i++) {
    Cadena = Cadena + respuesta[i].Resultado + "\n";
  }

  const blob = new Blob([Cadena], { type: "text/plain" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.download = "RTN.txt";
  link.href = url;

  link.click();
};

export function ExportarBanco() {
  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();

  const navigateToInicio = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Exportar a banco
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Segment style={estiloSegmento.Administrador}>
          <Form>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Alert severity="info">
              Archivo <b>ORDENES DE PAGO (OPG.TXT)</b>
              <br></br>
              <br></br>
              Contiene el detalle de las transferencias a realizar a los
              conductores en concepto de pago de viajes
            </Alert>
            <br></br>
            <div style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={() => {
                  ExportarOpa();
                }}
              >
                Exportar (OPG.TXT)
              </Button>
            </div>
            <Divider></Divider>
            <Alert severity="info">
              Archivo <b>RETENCIONES (RTN.TXT)</b>
              <br></br>
              <br></br>
              Contiene el detalle de las retenciones a realizar a los
              conductores en concepto de pago de viajes
            </Alert>
            <br></br>
            <div style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={() => {
                  ExportarRtn();
                }}
              >
                Exportar (RTN.TXT)
              </Button>
            </div>
          </Form>
        </Segment>
      </div>
    </div>
  );
}
